/**
 * Keep excerpt text readable when truncating saved rich text.
 * Handles paragraph joins like `?"Give` as well as simple joins like `.Next`.
 */
export function normalizeExcerptSpacing(text: string): string {
  return (text || '')
    .replace(/([.!?])(["'”’)\]]*)(?=[A-Z0-9])/g, '$1$2 ')
    .replace(/\s+/g, ' ')
    .trim();
}
